import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const TotalResults = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.gray.dark};
  white-space: nowrap;
  margin-left: 100px;
  margin-top: auto;
  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 20px;
    margin-left: 0;
    text-align: right;
  }
`;

export const Filters = styled.div`
  min-width: 30%;
  width: 30%;

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
  }
`;

export const Filter = styled.div`
  margin-bottom: 20px;
`;
export const ListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const List = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-self: flex-start;
  margin-left: 20px;

  @media ${({ theme }) => theme.devices.tablet} {
    margin-left: 0;
  }
`;

export const NoResults = styled.span`
  margin-top: 20px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  color: ${({ theme }) => theme.colors.gray.dark};
  letter-spacing: 1px;
  flex-grow: 1;
`;

export const EmptyItem = styled.div`
  width: 280px;
  height: 130px;
  margin-bottom: 20px;
`;

export const MobileFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  margin 0 auto;
  margin-top: 20px;
  @media ${({ theme }) => theme.devices.mobileM} {
  width: 100%;
}
`;

export const ButtonContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: start;
  text-align: center;
  align-items: center;
  gap: 10px;
  width: calc(100%);
  border: 1px solid ${({ theme }) => theme.colors.gray.light};
  padding: 5px;
  font-size: ${({ theme }) => theme.fontSizePx.mm};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grayNew.gray3};
  overflow: visible;
  height: 24px;
  padding: 0 40px;

  @media ${({ theme }) => theme.devices.tabletS} {
    height: 20px;
    font-size: ${({ theme }) => theme.fontSizePx.sm};
  }
`;

export const SelectorContainer = styled.div`
  display: flex;
  // height: 100%;
  align-self: center;
  align-items: center;
  justify-content: center;
`;

export const Expand = styled.div`
  margin-left: auto;
  font-size: 12px;
  align-self: center;
`;

export const FormContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white.normal};
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.grayNew.gray1};
  margin: 0px 20px 0 20px;

  @media ${({ theme }) => theme.devices.laptopM} {
    margin: 0px 10px 0 10px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    position: relative;
    z-index: 8;
    margin: 20px 15px 0 15px;
    border-radius: 4px;
    border: none;
  }
`;

export const Search = styled.input`
  border: none;
  padding: 0px 8px;
  height: auto;
  max-height: 60px;
  min-height: 30px;
  font-size: ${({ theme }) => theme.fontSize.mm};
  font-family: ${({ theme }) => theme.fonts.inter};
  border: 1px solid ${({ theme }) => theme.colors.grayNew.gray1};
  border-right: none;
  @media ${({ theme }) => theme.devices.tablet} {
    border-radius: 5px 0 0 5px;
  }
`;

export const SearchIcon = styled(FaSearch)`
  font-size: 19px;
  margin: 0 auto;
  font-weight: thin;
  color: ${props => props.theme.colors.white.normal};
`;

export const SearchBtn = styled.button`
  background-color: ${({ theme }) => theme.colors.green.normal};
  border: none;
  color: ${({ theme }) => theme.colors.white.normal};
  margin: 0;
  padding: 0 10px;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 10px;
  cursor: pointer;
  border-radius: 0 4px 4px 0;
`;
